<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
        استعلام قبوض
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-title style="color: red">
       با عرض پوزش این بخش در دست تکمیل می باشد و به زودی راه اندازی می شود.

      </v-card-title>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'Inquiry',


}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
